<h1 class="table__title">Link Document</h1>

<ul class="table__control inline-list">
  <li>
    <button mat-raised-button (click)="onNoClick()" color="accent">Close</button>
  </li>
  <li>
    <button mat-raised-button [mat-dialog-close]="selected" cdkFocusInitial [disabled]="selected?.length === 0"
      color="primary">Link</button>
  </li>
</ul>

<mat-tab-group class="tabs__section" #tabs [selectedIndex]="selectedTab">
  <mat-tab label="Search Filter">
    <app-search-filter [objectStore]="data.objectStore" [disabled]="loading$ | async" (search)="search($event)">
    </app-search-filter>
  </mat-tab>
  <mat-tab label="Search Results">
    <app-search-results (DocumentSelected)="resultSelect($event)" [fullTextResults]="false"
      [resultsExceeded]="resultsExceeded" [documentIds]="documentIds" [objectStore]="data.objectStore">
    </app-search-results>
  </mat-tab>
</mat-tab-group>

<div *ngIf="loading$ | async" class="spinner">
  <mat-spinner></mat-spinner>
</div>
